import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { ModalController } from "ionic-angular";

@Component({
  selector: "app-select-modal",
  templateUrl: "select-modal.html",
})
export class SelectModalComponent implements OnChanges {

  @Input() public list: any[] = [];
  @Input() public listSelected: any[] = [];
  @Input() public firstPrint: string;
  @Input() public secondPrint: string = null;
  @Input() public thirdPrint: string = null;
  @Input() public title: string = "Select";
  @Input() public buttonName: string;
  @Input() public isSingle: boolean = false;
  @Input() public isDisabled: boolean = false;
  @Input() public search: any[] = [];
  @Input() public aditionalCustom: "addReserveServices" = null;
  @Output() public sendSelected = new EventEmitter();

  public numSelected: number;
  public resultSelected: any[] = [];

  constructor(
    private modalCtrl: ModalController,
  ) { }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.listSelected) {
      this.numSelected = Object.keys(this.listSelected).length;
    }
  }

  public openModal() {
    this.isDisabled = true;
    const modal = this.modalCtrl.create("SelectModalPage", {
      aditionalCustom: this.aditionalCustom,
      firstPrint: this.firstPrint,
      isSingle: this.isSingle,
      list: this.list,
      listSelected: this.listSelected,
      search: this.search,
      secondPrint: this.secondPrint,
      thirdPrint: this.thirdPrint,
      title: this.title,
    });

    modal.present();

    modal.onWillDismiss(() => this.isDisabled = false);

    modal.onDidDismiss((response) => {
      if (response) {
        if (response.result) {
          this.resultSelected = response.result;
          this.numSelected = Object.keys(response.result).length;
          this.sendSelected.emit({ result: response.result });
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/select-modal/select-modal.ts